<template>
    <svg v-bind:class="[className, iconName]">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:xlink:href="getFullSvgIconUrl()"></use>
    </svg>
</template>

<script>
    export default {
        name: "svg-icon",
        data(){
            return {
                domain: window.env.baseUrl
            }
        },
        props: ["iconName", "className"],
        methods: {
            getFullSvgIconUrl () {
                return this.domain + '/svg/icons.svg#' + this.iconName;
            }
        }
    }
</script>
